function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/observer/observer
 */
import DomEmitterMixin from '@ckeditor/ckeditor5-utils/src/dom/emittermixin';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
/**
 * Abstract base observer class. Observers are classes which listen to DOM events, do the preliminary
 * processing and fire events on the {@link module:engine/view/document~Document} objects.
 * Observers can also add features to the view, for instance by updating its status or marking elements
 * which need a refresh on DOM events.
 *
 * @abstract
 */

var Observer = /*#__PURE__*/function () {
  /**
   * Creates an instance of the observer.
   *
   * @param {module:engine/view/view~View} view
   */
  function Observer(view) {
    _classCallCheck(this, Observer);

    /**
     * An instance of the view controller.
     *
     * @readonly
     * @member {module:engine/view/view~View}
     */
    this.view = view;
    /**
     * A reference to the {@link module:engine/view/document~Document} object.
     *
     * @readonly
     * @member {module:engine/view/document~Document}
     */

    this.document = view.document;
    /**
     * The state of the observer. If it is disabled, no events will be fired.
     *
     * @readonly
     * @member {Boolean}
     */

    this.isEnabled = false;
  }
  /**
   * Enables the observer. This method is called when the observer is registered to the
   * {@link module:engine/view/view~View} and after {@link module:engine/view/view~View#forceRender rendering}
   * (all observers are {@link #disable disabled} before rendering).
   *
   * A typical use case for disabling observers is that mutation observers need to be disabled for the rendering.
   * However, a child class may not need to be disabled, so it can implement an empty method.
   *
   * @see module:engine/view/observer/observer~Observer#disable
   */


  _createClass(Observer, [{
    key: "enable",
    value: function enable() {
      this.isEnabled = true;
    }
    /**
     * Disables the observer. This method is called before
     * {@link module:engine/view/view~View#forceRender rendering} to prevent firing events during rendering.
     *
     * @see module:engine/view/observer/observer~Observer#enable
     */

  }, {
    key: "disable",
    value: function disable() {
      this.isEnabled = false;
    }
    /**
     * Disables and destroys the observer, among others removes event listeners created by the observer.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.disable();
      this.stopListening();
    }
    /**
     * Checks whether a given DOM event should be ignored (should not be turned into a synthetic view document event).
     *
     * Currently, an event will be ignored only if its target or any of its ancestors has the `data-cke-ignore-events` attribute.
     * This attribute can be used inside the structures generated by
     * {@link module:engine/view/downcastwriter~DowncastWriter#createUIElement `DowncastWriter#createUIElement()`} to ignore events
     * fired within a UI that should be excluded from CKEditor 5's realms.
     *
     * @param {Node} domTarget The DOM event target to check (usually an element, sometimes a text node and
     * potentially sometimes a document, too).
     * @returns {Boolean} Whether this event should be ignored by the observer.
     */

  }, {
    key: "checkShouldIgnoreEventFromTarget",
    value: function checkShouldIgnoreEventFromTarget(domTarget) {
      if (domTarget && domTarget.nodeType === 3) {
        domTarget = domTarget.parentNode;
      }

      if (!domTarget || domTarget.nodeType !== 1) {
        return false;
      }

      return domTarget.matches('[data-cke-ignore-events], [data-cke-ignore-events] *');
    }
    /**
     * Starts observing the given root element.
     *
     * @method #observe
     * @param {HTMLElement} domElement
     * @param {String} name The name of the root element.
     */

  }]);

  return Observer;
}();

export { Observer as default };
mix(Observer, DomEmitterMixin);